.d6{border-radius:0.625rem;}